var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dev',[_c('el-cascader',{staticStyle:{"width":"80%"},attrs:{"model":_vm.indexes,"value":_vm.indexes,"options":_vm.options,"props":_vm.props,"clearable":""},on:{"change":_vm.handleChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }